import React from "react";
import TextField from "@material-ui/core/TextField/TextField";
import {useForm,} from "react-hook-form";
import {trimStart} from "lodash";

export type PropsTextNumber = {
  label: string         // label
  value: number         // 入力値
  setValue: any         // 入力値セット関数
  minValue: number      // 入力最小値
  maxValue: number      // 入力最大値
  isDisabled: boolean   // 不活化
  required: boolean     // 必須
  message?: string      // エラーメッセージ
  inputType?: string;   // テキストフィールドタイプ
}

interface TextNumberProps {
  propsText: PropsTextNumber
};

// テキスト数値フィールド表示
export default function ApolloTextNumber(props: TextNumberProps) {

  const {errors, setError, clearErrors,} = useForm();

  const {
    label,
    value,
    setValue,
    minValue,
    maxValue,
    isDisabled,
    required,
    message,
    inputType = "number"
  } = props.propsText;

  let valueTemp = value;
  // テキストフィールド変更ハンドラ
  const handleChangeValue = (event: any) => {
    valueTemp = parseInt(event.target.value ? event.target.value : "0");
    event.target.value = trimStart(event.target.value, "0");
    if (message === undefined) {
      // 入力値チェック
      if (valueTemp < minValue) {
        setError("name", {
          type: "manual",
          message: minValue + " 以上を入力して下さい。"
        })
        return;
      }
      if (valueTemp > maxValue) {
        setError("name", {
          type: "manual",
          message: maxValue + " 以下を入力して下さい。"
        })
        return;
      }
    }
    clearErrors("name");
    // 入力値チェック
    if (valueTemp < minValue) {
      valueTemp = minValue;
    }
    setValue(valueTemp);
  };

  return (
    <div>
      <TextField
        id="id"
        name="name"
        label={label}
        inputProps={{type: inputType, min: minValue}}
        required={required}
        fullWidth
        key={`${label}_${value}` ? "Loaded" : "Loading"}
        value={valueTemp}
        helperText={message ? message : errors.name && errors.name.message}
        error={message ? message !== "" ? true : false : errors.name ? true : false}
        disabled={isDisabled}
        onChange={handleChangeValue}
        onKeyDown={((e) => {
          // 数値、Ctlr+(a-z)以外の入力は無視するように制御
          if(e.key.match(/^[^0-9\c[a-z]]$/)){
            e.preventDefault()
          }
        })}
      />
    </div>
  )
}
